<template>
    <button v-if="submit" :class="className" type="submit" :disabled="isDisabled">
        <slot />
    </button>
    <a v-else-if="link" :href="link" :class="className" @click="onClick($event)">
        <slot />
        <form ref="form" :method="formMethod" :action="link" v-show="false" v-if="link && linkMethod.toUpperCase() !== 'GET'">
            <input type="hidden" name="_method" :value="linkMethod">
            <input type="hidden" name="_token" :value="token">
        </form>
    </a>
    <button v-else :class="className" @click="onClick($event)" :disabled="isDisabled">
        <slot />
    </button>
</template>

<script>
    export default {
        props: {
            submit: {
                type: String,
                default: ''
            },
            type: {
                default: 'default'
            },
            link: {
                default: ''
            },
            preventDefault: {
                type: Boolean,
                default: null
            },
            isDisabled: {
                type: Boolean,
                default: false
            },
            block: {
                type: Boolean,
                default: false
            },
            linkMethod: {
                type: String,
                default: 'get'
            },
            confirmMessage: {
                type: String,
                default: ''
            }
        },
        methods: {
            onClick(e) {
                if (this.isPreventDefault || this.isDisabled) {
                    e.preventDefault();
                }

                if (this.confirmMessage.length > 0) {
                    if (!confirm(this.confirmMessage)) {
                        e.preventDefault();
                        return;
                    }
                }

                if (this.link && !this.isPreventDefault && this.linkMethod.toUpperCase() !== 'GET') {
                    e.preventDefault();
                    this.$refs.form.submit();
                }

                if (!this.isDisabled) {
                    this.$emit('click', e);
                }
            }
        },
        computed: {
            className() {
                const availableClasses = ['primary', 'default', 'dark', 'success', 'error', 'light', 'warning', 'info', 'link', 'primary-link'],
                    typeClass = ~availableClasses.indexOf(this.type) ? this.type : 'default',
                    buttonClasses = ['app-button', typeClass];

                if (this.isDisabled) {
                    buttonClasses.push('disabled');
                }

                if (this.block) {
                    buttonClasses.push('block');
                }

                return buttonClasses.join(' ');
            },
            formMethod() {
                return this.linkMethod === 'GET' ? 'GET' : 'POST';
            },
            isPreventDefault() {
                if (this.preventDefault === null) {
                    return !this.link;
                }
                return this.preventDefault;
            },
            token() {
                return document.head.querySelector('meta[name="csrf-token"]').content;
            }
        }
    }
</script>

<style scoped lang="scss">
    @import "../../sass/mixin";
    @import "../../sass/variables";

    a, button {
        display: inline-flex;
        color: #212529;
        text-align: center;
        vertical-align: middle;
        cursor: pointer;
        -webkit-user-select: none;
        -moz-user-select: none;
        -ms-user-select: none;
        user-select: none;
        background-color: transparent;
        padding: 0.5rem 1.2rem;
        line-height: 1.5;
        border-radius: .25rem;
        transition: color .15s ease-in-out, background-color .15s ease-in-out, border-color .15s ease-in-out, box-shadow .15s ease-in-out;
        border: 0;
        font-weight: 500;
        box-shadow: 0 -1px 0 0 rgba(0, 0, 0, 0.2) inset;
        min-height: 38px;
        align-items: center;
        justify-content: center;
        @include md-max{
            width: 100%;
            margin-bottom: 15px;
        }

        &.primary {
            color: #fff;
            background-color: #0060D6;
        }

        &.secondary {
            color: #fff;
            background-color: #6c757d;
        }

        &.success {
            color: #fff;
            background-color: #28a745;
        }

        &.error {
            color: #fff;
            background-color: #dc3545;
        }

        &.warning {
            color: #ffffff;
            background-color: #ffc107;
        }

        &.info {
            color: #fff;
            background-color: #17a2b8;
        }

        &.primary-link {
            color: #fff;
            background-color: #5eb4dd;
        }

        &.light {
            color: #212529;
            background-color: #f8f9fa;
        }

        &.dark {
            color: #fff;
            background-color: #343a40;
        }

        &.link {
            color: #007bff;
            text-decoration: none;
        }

        ion-icon {
            margin-right: 5px;
        }
    }
</style>
